/* CANFOTO V67BS-R7 — NEW, READ-ONLY bridge to existing R2G panel capability owner.
   Does not infer effective power from nominal watt. Does not write DOM, scores, ranks or F/P. */
(function(W){'use strict';
var VERSION='CANFOTO-NORA-PANEL-SOURCE-BRIDGE-V67BS-R7';
var KEYS=Object.freeze(['product_ecommerce::small_product_tabletop','interview_talking_head::single_interview','interview_talking_head::two_person_interview','clinic_aesthetic_dental::dental_support','rgb_creative_video::background_color_effect']);
var LANES=Object.freeze(['BARE_LIGHT','SINGLE_READY_SET']);
function clean(v){return String(v==null?'':v).trim();}
function pos(v){if(v===null||v===undefined||v==='')return null;var n=Number(v);return Number.isFinite(n)&&n>=0?n:null;}
async function audit(options){
 options=options||{};
 var projection=W.GDX_PANEL_V4_R2D_EXACT_SELECTION_SCORE_PROJECTION;
 var owner=W.GDX_PANEL_V4_R2G_EFFECTIVE_POWER_ROLE_TRUTH;
 var oldAudit=W.CANFOTO_NORA_PANEL_REAL_CAPACITY_AUDIT_V67BS_R6;
 if(typeof projection?.getRowsAsync!=='function'||typeof projection?.getRows!=='function')throw Error('HOLD_NATIVE_PROJECTION_MISSING');
 if(typeof owner?.getCapability!=='function')throw Error('HOLD_R2G_CAPABILITY_OWNER_MISSING');
 var keys=Array.isArray(options.keys)&&options.keys.length?options.keys:KEYS;
 var lanes=Array.isArray(options.lanes)&&options.lanes.length?options.lanes:LANES;
 var reports=[], parity=true, sourceCount=0, missing=0, ownerMissing=0, handleMissing=0, collisions=[];
 for(var i=0;i<keys.length;i++)for(var j=0;j<lanes.length;j++){
  var key=clean(keys[i]),lane=clean(lanes[j]);
  var rows=await projection.getRowsAsync(key,{lane:lane,limit:0});
  var sync=projection.getRows(key,{lane:lane,limit:0});
  if(JSON.stringify(rows)!==JSON.stringify(sync))parity=false;
  var items=rows.map(function(row,index){
   var handle=clean(row?.handle||projection.rowHandle?.(row));
   var cap=handle?owner.getCapability(handle,key):null;
   var v=pos(cap?.effectiveWhitePowerW);
   if(!handle)handleMissing++;
   if(!cap)ownerMissing++;
   if(v!==null)sourceCount++;else missing++;
   var capabilityLane=clean(cap?.lane);
   if(capabilityLane&&capabilityLane!==lane)collisions.push({selectionKey:key,lane:lane,handle:handle,ownerLane:capabilityLane});
   return {rank:index+1,handle:handle,lane:lane,technicalSourceHandle:clean(cap?.technicalSourceHandle)||null,
     effectiveWhitePowerW:v,nominalPowerW:pos(cap?.nominalPowerW),channelArchitecture:clean(cap?.channelArchitecture)||null,
     primaryRoleKey:clean(cap?.primaryRoleKey)||null,areaKey:clean(cap?.areaKey)||null,
     distanceBands:Array.isArray(cap?.distanceBands)?cap.distanceBands.slice():[],mainKeyEligible:cap?.mainKeyEligible===true,
     evidence:v!==null?'EXISTING_R2G_P47_MODEL':'UNKNOWN',sourcePolicy:cap?.sourcePolicy?.effectivePower||null,
     noLuxCertification:true};
  });
  reports.push({selectionKey:key,lane:lane,count:items.length,items:items});
 }
 var total=reports.reduce(function(n,r){return n+r.count;},0);
 var status=!parity?'HOLD_CANONICAL_PARITY':collisions.length?'HOLD_LANE_MISMATCH':'PASS_READ_ONLY_SOURCE_BRIDGE';
 return {version:VERSION,mode:'READ_ONLY_SHADOW',status:status,canonicalAsyncSyncEqual:parity,
  selectionCount:keys.length,laneCount:lanes.length,totalRows:total,
  rowsWithR2GEffectiveWhiteW:sourceCount,rowsMissingR2GEffectiveWhiteW:missing,
  rowsMissingOwnerCapability:ownerMissing,rowsMissingHandle:handleMissing,laneMismatchCount:collisions.length,
  laneMismatches:collisions,records:reports,ownerVersion:owner.version||null,r6Available:typeof oldAudit?.audit==='function',
  photometryCertifiedCount:0,scoreMutation:false,rankMutation:false,fpCurveMutation:false};
}
W.CANFOTO_NORA_PANEL_TECH_SOURCE_BRIDGE_V67BS_R7=Object.freeze({version:VERSION,audit:audit,
 scoreMutation:false,rankMutation:false,fpCurveMutation:false});
})(window);
